module.exports = __webpack_public_path__ + "static/img/亲子活动@2x (1).40321c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/亲子活动@2x (1).png
// module id = Ib+v
// module chunks = 1